import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: null
}

// getters
const getters = {
  getAllJalurData: state => state
}

// actions
const actions = {
  getAllJalur ({ commit }) {
    api.get('/v1/public/jalur')
      .then(response => {
        let responseData = response.data
        commit(types.JALUR_RECIEVE, responseData.data)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.JALUR_RECIEVE] (state, response) {
    state.all = response
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jalur.js